// check this to see which actions are supported:
// https://support.dynamicyield.com/hc/en-us/articles/360022557954-Recommendations-Client-Side-APIs#return-recommendation-real-time-filter-data-0-3
type ConditionArgument =
  | {
      action: 'GTE' | 'LTE';
      value: number;
    }
  | {
      action: 'IS';
      value: string | boolean;
    }
  | {
      action: 'CONTAINS';
      value: string;
    };

export interface DyRecommendationQueryCondition {
  field: string;
  arguments: ConditionArgument[];
}

export interface DyRecommendationRule {
  id: string;
  query: {
    conditions: DyRecommendationQueryCondition[];
  };
  type: 'include' | 'exclude';
  slots: number[];
}

export interface DyRecommendationSlot {
  productData: Record<string, any>;
  sku: string;
  slotId: string;
}

interface Variation {
  id: string;
  payload: {
    data: {
      custom: { title: string };
      slots: DyRecommendationSlot[];
    };
  };
}

interface DyRecommendationChoice {
  id: string;
  decisionId: string;
  name: string;
  type: string;
  variations: Variation[];
}

// wId, fId, and strId are for tracking dy recommendations, following link includes a documentation about it.
// https://support.dynamicyield.com/hc/en-us/articles/360022557954-Recommendations-Client-Side-APIs#track-recommendation-widget-0-4
export interface DyRecommendations {
  choices: DyRecommendationChoice[];
  cookies: Array<{ name: string; value: string; maxAge: string }>;
}

export enum DyRecommendationCampaign {
  CATEGORY_SLIDER = 'Category-Slider',
  //TODO: WISHLIST not implemented in DY yet
  WISHLIST = 'Wishlist-Slider',
}
